import { CHECK_ON_EXISTING_EMAIL } from './types';

export const checkOnExistingEmail = (payload) => {
  return {
    type: CHECK_ON_EXISTING_EMAIL,
    payload,
  };
};
